module.exports = __webpack_public_path__ + "static/media/cloud-d2-v3.9f66772d.svg";